interface PercentileAnchors {
  p50: number;
  p75: number;
  p90: number;
}

// Anchor the curve at (0th, 0.0) and (100th, 1.0) since CSAT is bounded on
// [0, 1] — not fabricated data, just the known domain limits the interpolation
// runs between.
function toAnchorPoints(anchors: PercentileAnchors): [number, number][] {
  return [
    [0, 0],
    [50, anchors.p50],
    [75, anchors.p75],
    [90, anchors.p90],
    [100, 1],
  ];
}

/** Piecewise-linear percentile rank of `score` (0-1) against the given anchors. */
export function scoreToPercentile(
  score: number,
  anchors: PercentileAnchors,
): number {
  const points = toAnchorPoints(anchors);
  const clamped = Math.min(1, Math.max(0, score));

  if (clamped >= 1) return 100;
  if (clamped <= 0) return 0;

  for (let i = 0; i < points.length - 1; i++) {
    const [p0, s0] = points[i];
    const [p1, s1] = points[i + 1];
    if (clamped >= s0 && clamped < s1) {
      const t = (clamped - s0) / (s1 - s0);
      return p0 + t * (p1 - p0);
    }
  }
  return 100;
}

export function ordinal(n: number): string {
  const rounded = Math.round(n);
  const mod100 = rounded % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${rounded}th`;
  switch (rounded % 10) {
    case 1:
      return `${rounded}st`;
    case 2:
      return `${rounded}nd`;
    case 3:
      return `${rounded}rd`;
    default:
      return `${rounded}th`;
  }
}
